import React from 'react';
import * as ST from './styled';
import { NON_BREAKING_SPACE } from '~/src/constants/simbols';
import Link from 'next/link';

const ButtonsBlockComponent = () => {
    return <>
        <ST.ButtonsBlock>
            <Link href={'/'} prefetch={false}>
                <ST.ButtonPersonalArea>Личный кабинет</ST.ButtonPersonalArea>
            </Link>
            <Link href={'/payments'} prefetch={false}>
                <ST.ButtonPay>Оплатить</ST.ButtonPay>
            </Link>
        </ST.ButtonsBlock>
        <ST.CopyrightText>Продолжая использовать наш сайт, вы даете согласие на обработку файлов
            cookies и других пользовательских данных, в соответствии с{NON_BREAKING_SPACE}
            <ST.CopyrightLink href='https://tcenter.ru/voprosy-i-otvety/dogovory-i-dokumenty/' >Политикой конфиденциальности</ST.CopyrightLink>.
        </ST.CopyrightText>
    </>;
};

export default ButtonsBlockComponent;
